import React, { useEffect } from 'react';
import { ThemeProvider as MuiThemeProvider } from '@mui/material/styles';
import { CssBaseline } from '@mui/material';
import { useRecoilValue } from 'recoil';
import { themeState } from '../Recoil/RecoilState';
import { createAppTheme } from '../utils/theme';
import { useThemePersistence } from '../hooks/useThemePersistence';
import { useLogoPersistence } from '../hooks/useLogoPersistence';

const ThemeProvider = ({ children }) => {
  const currentThemeMode = useRecoilValue(themeState);
  const theme = createAppTheme(currentThemeMode);
  
  // Initialize theme and logo persistence
  useThemePersistence();
  useLogoPersistence();

  // Apply CSS classes to document body based on theme mode
  useEffect(() => {
    const body = document.body;
    
    // Remove all theme-related classes
    body.classList.remove('light-theme', 'dark-theme', 'high-contrast-theme');
    
    // Add appropriate class based on current theme
    switch (currentThemeMode) {
      case 'light':
        body.classList.add('light-theme');
        break;
      case 'dark':
        body.classList.add('dark-theme');
        break;
      case 'highContrast':
        body.classList.add('high-contrast-theme', 'high-contrast');
        break;
      default:
        body.classList.add('dark-theme');
    }
  }, [currentThemeMode]);

  return (
    <MuiThemeProvider theme={theme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};

export default ThemeProvider; 